import { useState } from "react"
import { useDispatch } from "react-redux"
import { logout } from "src/api"
import { onLogout } from "../../store/account/actions"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import { getAPI_CALL_STARTED } from "../gaConstants"
export default () => {
  const [error, setError] = useState(undefined)
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()

  const execute = async () => {
    try {
      trackCustomEvent(getAPI_CALL_STARTED("LOGOUT_USER"))

      setLoading(true)
      setError(undefined)

      await logout()
    } catch (error) {
      Sentry.captureException(error)

      setError(error.message)
      throw error
    } finally {
      dispatch(onLogout())
      setLoading(false)
    }
  }

  return { error, loading, logout: execute }
}
